// convert a list : [{model: 'SET3G10', cartridgesNeeded: 0.6}, {model: 'SET3G22-N', cartridgesNeeded: 0.03}]


// into an object  { SET3G10: 0.6, SET3G22-N: 0.03 }
const buildModelObj = (list) => {
  return list.reduce((result, item) => {
    result[item.model] = item.cartridgesNeeded
    return result
  }, {})
}

export const calculationReducer = (state = [], action) => {
  switch (action.type) {
    case 'FIELD_SWITCH_SUBAPP': {
      state.input = action.payload
      state.output = {}
      return Object.assign({}, state)
    }
    case 'FIELD_INPUT_CALCULATION': {
      const myPayload = action.payload
      if (myPayload.length > 1) {
        state.input.validation = Object.assign({}, state.input.validation, myPayload[1])
        state.input = Object.assign({}, state.input, myPayload[0])
      } else {
        state.input = Object.assign({}, state.input, action.payload)
      }
      return Object.assign({}, state)
    }
    case 'FIELD_UPDATE_CALCULATION': {
      state.input = Object.assign({}, state.input, action.payload)
      return Object.assign({}, state)
    }
    case 'FIELD_OUTPUT_CALCULATION': {
      state.output = Object.assign({}, state.output, action.payload)
      return Object.assign({}, state)
    }
    case 'JOB_ADD': {
      let jobs = state.output.jobs || []
      jobs.push(action.payload)
      state.output.jobs = jobs
      state.status = Object.assign({}, state.status, { updateJobIndex: jobs.length - 1 })

      return Object.assign({}, state)
    }
    case 'JOB_REPLACE': {
      state.output.jobs = action.payload
      return Object.assign({}, state)
    }
    case 'JOB_CLEANUP': {
      state.output = {}
      return Object.assign({}, state)
    }
    case 'JOB_REMOVE': {
      const lastRowIndex = state.output.jobs.length - 1
      const editRowIndex = state.status.updateJobIndex
      const deleteRowIndex = action.payload.removeJobIndex

      if (deleteRowIndex === editRowIndex) {
        // newEditRow should be the lastRow in jobs
        state.output.jobs.splice(deleteRowIndex, 1)
        const newLastRowIndex = lastRowIndex - 1
        const userInputs = state.output.jobs[newLastRowIndex].userInputs
        // const inputs = userInputs  //DC JSON.parse(userInputs)
        state.input = Object.assign({}, state.input, userInputs)
        state.status = Object.assign({}, state.status, { updateJobIndex: newLastRowIndex })
      } else if (deleteRowIndex < editRowIndex) {
        state.output.jobs.splice(deleteRowIndex, 1)
        state.status = Object.assign({}, state.status, { updateJobIndex: editRowIndex - 1 }) // same editRow, but different index
      } else {
        state.output.jobs.splice(deleteRowIndex, 1)
      }

      return Object.assign({}, state)
    }
    case 'JOB_UPDATE_INIT': {
      const index = action.payload.updateJobIndex
      const userInputs = state.output.jobs[index].userInputs

      state.input = Object.assign({}, state.input, userInputs)
      state.status = Object.assign({}, state.status, {
        updateJobIndex: action.payload.updateJobIndex,
      })
      return Object.assign({}, state)
    }
    case 'JOB_UPDATE_COMPLETE': {
      const index = state.status.updateJobIndex
      state.output.jobs[index] = action.payload
      state.status = Object.assign({}, state.status, { updateJobIndex: null })
      return Object.assign({}, state)
    }
    case 'MOBILEVIEW_ORDER': {
      state.status = Object.assign({}, state.status, {
        mobileViewOrderCounter: state.status.mobileViewOrderCounter + 1,
      })
      return Object.assign({}, state)
    }
    case 'CALCULATION_INIT': {
      state.status = Object.assign({}, state.status, {
        isLoading: true,
        isError: false,
        msgLevel: '',
        msgHeader: '',
        msgBody: '',
      })
      return Object.assign({}, state)
    }
    case 'CALCULATION_SUCCESS': {
      let updateJobIndex = state.status.updateJobIndex

      if (state.input.subApp === '0') {
        const myUserInputs = Object.assign({}, state.input)
        delete myUserInputs.results
        delete myUserInputs.jobs
        delete myUserInputs.validation
        delete myUserInputs.subApp
        delete myUserInputs.source
        delete myUserInputs.sourceDomain
        delete myUserInputs.adhesiveAnchorModel

        const modelObj = buildModelObj(action.payload.results)

        if (!state.output.jobs || state.output.jobs.length === 0) {
          // if jobs is empty
          updateJobIndex = 0
          const theJob = Object.assign({}, { jobName: 'Job ' + (updateJobIndex + 1) }, modelObj, {
            userInputs: myUserInputs,
          })

          action.payload.jobs = [theJob]
        } else {
          const theJob = Object.assign({}, modelObj, { userInputs: myUserInputs })

          state.output.jobs[updateJobIndex] = Object.assign(
            {},
            state.output.jobs[updateJobIndex],
            theJob,
          )
        }
      }
      state.output = Object.assign({}, state.output, action.payload)
      state.status = Object.assign({}, state.status, {
        isLoading: false,
        isError: false,
        updateJobIndex: updateJobIndex,
      })
      return Object.assign({}, state)
    }
    case 'CALCULATION_FAILURE': {
      state.status = Object.assign(
        {},
        state.status,
        { isLoading: false, isError: true },
        action.payload.status,
      )
      if (state.output.jobs) {
        state.output = Object.assign({}, { jobs: state.output.jobs })
      } else {
        state.output = {
          injectionResinResults: [],
          pasteOverEpoxyResults: [],
          pumpingPortsResults: [],
          injectionFittingsResults: [],
        }
      }
      return Object.assign({}, state)
    }
    default:
      return state
  }
}
